import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import { SideBarData } from './SideBarData';
import SubMenu from './SubMenu';
import { IconContext } from 'react-icons/lib';
import { tipoMenuEnum } from '../../enum/index';
import { ValidarEmisor, ValidarLogin } from '../../util';
import { connect } from 'react-redux';
import { IsNotNullOrEmptyOrUndefined } from '../../util';

const Sidebar = (props) => {
  const [sidebar, setSidebar] = useState(false);
  const showSidebar = () => setSidebar(!sidebar);
  const { token } = ValidarLogin(props);
  const { emisor } = ValidarEmisor(props);

  const displayNombreComercial = () => {
    let nombreComercial = emisor.Nombre;
    let casaMatriz = '001';

    if (emisor.usuario.split('-').length == 2 && Array.isArray(emisor?.Sucursales)) {
      casaMatriz = emisor.usuario.split('-')[1];

      let sucursal = emisor?.Sucursales?.find(x => x.CasaMatriz === casaMatriz);

      nombreComercial = IsNotNullOrEmptyOrUndefined(sucursal) ? sucursal.NombreComercial : emisor.Nombre;
    }

    if (IsNotNullOrEmptyOrUndefined(emisor?.NombreComercial) && casaMatriz !== '001') {
      return nombreComercial;
    }

    return IsNotNullOrEmptyOrUndefined(emisor?.NombreComercial) ? emisor?.NombreComercial :  emisor?.Nombre;
  }

  return (
    <>
      {
        (token && emisor) && (
          <IconContext.Provider value={{ color: 'green' }}>
            <div className='ui grid main-header'>
              <div className='four wide column'>
                <div className="navbar">
                  <Link to="#" className="menu-bars">
                    <FaIcons.FaBars onClick={showSidebar} />
                  </Link>
                </div>
              </div>
              <div className='twelve wide column display-name'>
                <span className='title'>{displayNombreComercial()}</span></div>
            </div>

            <nav className={sidebar ? 'nav-menu active' : 'nav-menu'}>
              <ul className="nav-menu-items"  >
                <li className="navbar-toggle">
                  <Link to="#" onClick={showSidebar} className="menu-bars">
                    <AiIcons.AiOutlineClose />
                  </Link>
                </li>
                {SideBarData.map((item, index) => {
                  if (item?.tipo === tipoMenuEnum.SubMenu) {
                    return <SubMenu SideBarData={SideBarData} showSidebar={showSidebar} item={item} key={index} />
                  } else {
                    return (
                      <li key={index} className={'nav-text'}>
                        <Link to={item.path} onClick={showSidebar} >
                          {item.icon}
                          <span>{item.title}</span>
                        </Link>
                      </li>
                    )
                  }
                })}
              </ul>
            </nav>
          </IconContext.Provider>
        )
      }
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    loginState: state.loginState,
    emisorState: state.emisorState,
  };
}

export default connect(mapStateToProps, {})(Sidebar);
